'use client';

import { Portal } from '@radix-ui/react-portal';
import { ReactNode } from 'react';
import { useEvent } from 'react-use';
import { AudioStockItem } from 'search-gateway-client';

import {
    CollapsibleContent,
    CollapsibleRoot,
    CollapsibleRootProps,
    CollapsibleTrigger,
} from '@videoblocks/design-system';

import { StockItemContext, StockItemDrawerType, StockItemUserData } from '../../elements/StockItemTypes';
import { DRAWER_EVENTS, ExpandDrawerEvent } from '../../events/DrawerEvents';
import AudioStockItemCard from './AudioStockItemCard';

export interface AudioAltVersionCollapsibleProps extends CollapsibleRootProps {
    currStockItem: AudioStockItem;
    stockItems: AudioStockItem[];
    trigger: ReactNode;
    portalContainer?: HTMLElement | null;
    userData: StockItemUserData;
}

export const AudioAltVersionCollapsible = ({
    currStockItem,
    stockItems = [],
    onOpenChange,
    open,
    trigger,
    portalContainer = null,
    userData,
}: AudioAltVersionCollapsibleProps) => {
    useEvent(DRAWER_EVENTS.EXPAND, (event: ExpandDrawerEvent) => {
        if (currStockItem.id !== event.initialItemId && open) {
            onOpenChange?.(false);
        }
    });

    return (
        <CollapsibleRoot data-testid="audio-alt-version-collapsible-root" onOpenChange={onOpenChange} open={open}>
            <Portal container={portalContainer}>
                <CollapsibleContent data-testid="audio-alt-version-collapsible-content" asChild>
                    <div>
                        {stockItems.map((stockItem) => (
                            <div key={stockItem.id} className="ml-21">
                                <AudioStockItemCard
                                    stockItem={stockItem}
                                    context={StockItemContext.DRAWER}
                                    drawerContext={StockItemDrawerType.ALT_VERSIONS}
                                    userData={userData}
                                />
                            </div>
                        ))}
                    </div>
                </CollapsibleContent>
            </Portal>
            <CollapsibleTrigger asChild>
                <div>{trigger}</div>
            </CollapsibleTrigger>
        </CollapsibleRoot>
    );
};
